import React from "react";
import { Box } from "@bca/ui-library";
import { BoxProps } from "@bca/ui-library/dist/Box/box.type";

export interface MessageOptionsContainerProps extends BoxProps {}

const MessageOptionsContainer: React.FunctionComponent<MessageOptionsContainerProps> =
  (props) => {
    return <Box {...props}>{props.children}</Box>;
  };

export default MessageOptionsContainer;
